export default [
  {
    name: 'myPage',
    path: '',
    component: () => import('@/views/main/Main.vue'),
    meta: {
      auth: true,
    },
  },

  {
    path: 'practice',
    //component: LoginPage,
    component: () => import('@/views/play.vue'),
  },
  {
    name: 'cv',
    path: 'resume/:annoId',
    component: () => import('@/views/ResumePage.vue'),
    meta: {
      auth: true,
    },
  },
];
